// Checks for the cart checkbox and adds or removes the "Gift Wrap" product
// when selected. 
// Also, Every time the cart loads, it check if the "Gift Wrap" product is already on cart
// and set the input to checked if that's the case.
(function (){

  var wrapper = document.querySelector('[data-gift-wrap]');
  if(!wrapper){
    return ;
  }

  var input = wrapper.querySelector('input[name="Gift Wrap"]');
  var gwID = wrapper.dataset.giftWrap;
  var gwQuantity = 0;
  var sectionID = wrapper.dataset.sectionId;
  var parser = new DOMParser();
  
  updateGiftWrapInputOnLoad();
  
  input.addEventListener('input',function(){
    if(this.checked){
      var url = 'cart/add.js';
      var data = { 'items': [{  'id': gwID , 'quantity': 1  }], 'sections': sectionID + ',header' }        
    }else{  
      var url = 'cart/change.js';
      var data = { 'id':gwID ,'quantity':0,'sections': sectionID + ',header'}   
    }   
    updateCart(url,data).then(replaceSections).catch(function(error){ console.error('Error:', error);});
  });


  function replaceSections(data) {
      updateQuantity(data.items);      
      var cartReplacer = new SectionReplacer( parser, data.sections[sectionID] );
      var headerReplacer = new SectionReplacer( parser, data.sections['header'] );
      cartReplacer.replace('[data-cart-subtotal]');
      cartReplacer.replace('[data-cart-line-items]');
      headerReplacer.replace('[data-cart-count]');
      
    }
  
  function updateCart(url,body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(response) {
      return response.json();
    });
  
  }

  function updateGiftWrapInputOnLoad(){
    fetch('cart.js')
    .then(function(response){return response.json()})
    .then(function(data){ 
      if(updateQuantity(data.items)){
        input.checked = true;
      }
    });
  }

  function updateQuantity(items){
    var giftWrapItem = items.find(function(item){
      return item.id == gwID;
    });
    gwQuantity =  giftWrapItem ? giftWrapItem.quantity : 0;
    return giftWrapItem;
  }

// ES5 CLASS DECLARATION
  function SectionReplacer(parser,section){
    this.parser = parser;
    this.section = this.parser.parseFromString(section,"text/html");

    this.replace = function(selector){
      var newSection = this.section.querySelector(selector);
      var oldSection = document.querySelector(selector);
      if(newSection && oldSection){        
        oldSection.innerHTML = newSection.innerHTML;
      }
    }
  }

    
})();

(function(){
  var button = document.querySelector('[data-action="open-popup"]');
  if(!button){
    return;
  }
  
  var popup = document.getElementById(button.getAttribute('aria-controls'));
  if(!popup){
    return;
  }
  var closeButton = popup.querySelector('[data-action="close-popup"]');
  var backdrop = popup.querySelector('.backdrop');
  
  button.addEventListener('click',open);
  closeButton.addEventListener('click',close);
  backdrop.addEventListener('click',function(e){
    (e.target === this) && close();
  })
  document.addEventListener('keydown',function(e){
     (e.key === "Escape") && close(); 
  })
  
  function open(){
    popup.classList.add('is-open');
  }
  function close(){
    popup.classList.remove('is-open');
  }
  
})();